// Modra-only performance pilot: retain Object.keys(dictionary).length > 0 semantics
// without allocating the complete key array for every translated product control.
const knownKeys = new WeakMap<object, string>();
const isEnumerable = Object.prototype.propertyIsEnumerable;

export function hasTranslationKeys(dictionary: object): boolean {
  const knownKey = knownKeys.get(dictionary);
  // Validate the witness on every call: in-place deletion or descriptor changes
  // must not leave readiness stale. Empty dictionaries are never cached as false.
  if (knownKey !== undefined && isEnumerable.call(dictionary, knownKey)) return true;

  for (const key in dictionary) {
    if (isEnumerable.call(dictionary, key)) {
      knownKeys.set(dictionary, key);
      return true;
    }
  }

  knownKeys.delete(dictionary);
  return false;
}
